<div class="modal">
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h3>{{ item.title }}</h3>
  </section>
  <section mat-dialog-content>
    <div>
      <div [innerHTML]="item.description"></div>

      @if (item.file_type &&  item.file_type?.indexOf('image') > -1 && !item.thumbnails) {
        <div>
          <img alt="{{ item.file_title }}" src="{{'/product-extra-info-file/' + item.id + '/' + item.file_slug}}" />
        </div>
      }

      @if (item.thumbnails?.length === 0) {
        <div>
          @for (file of item.files; track file) {
            <div class="download">
              @if ( file.file_type &&
                file.file_type?.indexOf('image') == -1
                ) {
                <div class="download">
                  <a [href]="file.downloadUrl" target="_blank" rel="noopener noreferrer">
                    <img src="/app/assets/img/download.png" />
                    {{
                    removeFileExtension(file.file_title_display || file.file_title || 'download')
                    }}
                  </a>
                </div>
              }
            </div>
          }
        </div>
      }

      @if (item.thumbnails?.length > 0) {
        <image-carousel [slug]="item.id" class="modal-carousel"
        [items]="item.thumbnails"></image-carousel>
      }
    </div>
  </section>
</div>